module.exports = __webpack_public_path__ + "img/acceptableUpcCodesV2.95319e2e.png";